export default "__VITE_ASSET__CJTCZTi7__"